import { useMemo } from 'react';
import { getText } from 'i18n/intl';
import { Form, Select } from '@timeedit/ui-components/antd';
import { LabelWrapper } from '@timeedit/ui-components/components/InputComponent/Input';
import type { CommonProps } from './common';

const BulkEditCheckbox = ({ field }: CommonProps) => {
  const options = useMemo(
    () => [
      {
        value: 'keep',
        label: getText('object_manager.bulk-edit-modal.keep.label'),
      },
      {
        value: 'checkAll',
        label: getText('object_manager.bulk-edit-modal.checkAll.label'),
      },
      {
        value: 'uncheckAll',
        label: getText('object_manager.bulk-edit-modal.uncheckAll.label'),
      },
    ],
    []
  );

  return (
    <LabelWrapper label={field.name} tooltip={field.description}>
      <div className="bulk-edit-input-wrapper">
        <Form.Item required name={field.id}>
          <Select defaultValue="keep" options={options} />
        </Form.Item>
      </div>
    </LabelWrapper>
  );
};

export default BulkEditCheckbox;
